import React from 'react';
import { Box } from 'grommet';
import SHDModal from '@ui/Modal/SHDModal';
import SHDText from '@ui/Text/SHDText';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';

interface Props {
  onCloseModal: () => void;
  goBack?: () => void;
  title: string;
  headerText: string;
  children: React.ReactNode;
}

export const LiveStreamSettingsModal: React.FC<Props> = ({
  onCloseModal,
  goBack,
  title,
  headerText,
  children,
}) => {
  return (
    <SHDThemeOverride full={false}>
      <SHDModal onClose={onCloseModal} onGoBack={goBack} isFixedHeight={true}>
        <SHDModalContainer>
          <Box gap="large" margin="xxsmall" fill="vertical">
            <Box gap="xsmall">
              <SHDText
                size={'body-semibold'}
                style={'body-semibold'}
                color="gray-500"
              >
                {headerText}
              </SHDText>
              <SHDHeading level={3} formatCasing={false}>
                {title}
              </SHDHeading>
            </Box>
            <Box flex="grow" overflow="auto" gap="small">
              {children}
            </Box>
          </Box>
        </SHDModalContainer>
      </SHDModal>
    </SHDThemeOverride>
  );
};
